module.exports = __webpack_public_path__ + "static/img/Visualization13.f992efe4.png";